// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"f72298a9","629":"68145307","924":"d2f76870"}[chunkId] + ".chunk.js");